import { Button } from "./ui/button";
import { Plane } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-sky-50 to-teal-100 dark:from-slate-900 dark:to-blue-950 pb-12 pt-28 md:pt-32">
      <img
        src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1100&q=80"
        alt="Travel hero"
        className="absolute top-0 left-0 w-full h-full object-cover object-center opacity-30 blur-sm pointer-events-none select-none dark:opacity-20"
        draggable={false}
      />
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 dark:text-white drop-shadow-md tracking-tight text-center max-w-2xl">
          Plan Your Next <span className="bg-gradient-to-r from-teal-400 to-blue-500 bg-clip-text text-transparent">Adventure</span>
        </h1>
        <p className="mt-6 text-lg md:text-2xl text-slate-700/80 dark:text-slate-200/70 font-medium max-w-xl text-center">
          Effortlessly craft, visualize & share your travel dreams – with a few clicks.
        </p>
        <Button
          size="lg"
          className="mt-10 px-8 py-5 text-lg font-semibold shadow-xl rounded-xl hover:scale-105 transition-transform group bg-gradient-to-tr from-sky-400 to-teal-400 text-white gap-2"
        >
          Start Planning <Plane className="w-5 h-5 ml-2 group-hover:-rotate-12 transition-transform" />
        </Button>
      </div>
    </section>
  );
};

export default HeroSection;
